import { Component, OnDestroy, OnInit, forwardRef, DoCheck, ChangeDetectorRef, Inject, Input, EventEmitter, Output } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ICardComponentInjectionToken } from '@infrastructure/ValidationMessages/ExternalValidationDirective';

import { CommonData } from '@infrastructure/CommonData/CommonDataResolver';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from '@infrastructure/Modal/ModalService';
import { confirmRemoveFromList } from '@infrastructure/TableEdit/TableEditBase';
import { isNotNullOrUndefinedOrEmpty, isNullOrUndefined } from '@infrastructure/objectUtils';

import { BeneficiaryHelperService } from '@infrastructure/Beneficiaries/BeneficiaryHelperService';
import { LegalRepresentationStateService } from '@infrastructure/Beneficiaries/legal-representation-state.service';
import { NifValidationService } from '@infrastructure/NifValidation/nif-validation.service';


@Component({
  selector: 'beneficiary-list-pre-stage',
  templateUrl: './beneficiary-list-pre-stage.component.html',
  providers: [
    {
      provide: ICardComponentInjectionToken,
      useExisting: forwardRef(() => BeneficiaryListPreStageComponent)
    }],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})

export class BeneficiaryListPreStageComponent implements OnInit, OnDestroy {

  

  @Output() isOnEdit = new EventEmitter<boolean>();
  @Input()  model: models.BeneficiaryVM = {} as models.BeneficiaryVM;

  @Input() senderNIF: number;
  @Input() hasLegalRepresentation: string;
  @Input() isFuneraryOrService: boolean = false;
  @Input() workflowInstanceId: number;
  @Input() deceasedSubscriberNumber: number;
  @Input() workflowCode: string;
  @Output() listChanged = new EventEmitter<models.BeneficiaryListVM[]>();
  @Input() dropdowns: models.WorkflowDropdownsVM;
  @Input() qualificationIsBeneficiary: boolean;
  @Input() qualificationIsLegalRepresentative: boolean = null;
  @Input() deathDate: Date;
  @Input() nifDeceased: string;
  @Input() estadoPendente: boolean;

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.country)
  public countries: models.DimensionVM[];
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];
  @CommonData(DomainCodes.subscriberType)
  public subscriberTypes: models.DimensionVM[];
  @CommonData(DomainCodes.nationality)
  public nationalities: models.DimensionVM[];
  @CommonData(DomainCodes.genders)
  public genders: models.DimensionVM[];

  public maritalStatus: models.Options[];
  @CommonData(DomainCodes.identificationType)
  public documentTypes: models.DimensionVM[];
  @CommonData(DomainCodes.fiscalCategories)
  public fiscalCategories: models.DimensionVM[];
  @CommonData(DomainCodes.incomeHolding)
  public incomeHoldings: models.DimensionVM[];
  @CommonData(DomainCodes.bankAccountTypes)
  public bankAccountTypes: models.DimensionVM[];


  @CommonData(DomainCodes.studyLevel)
  public educationLevel: models.DimensionVM[];



  public expandNewBeneficiary: boolean = false;
  public expandedRowIndex: number = null;


  constructor(
    private http: HttpClient, private activeRoute: ActivatedRoute, private modalService: ModalService,
    private BeneficiaryHelperService: BeneficiaryHelperService,
    private legalRepresentationState: LegalRepresentationStateService,
    private nifValidationService: NifValidationService
  ) {
  }


  ngOnInit(): void {
  
  }

  ngOnDestroy(): void {
  }

  public getStateColor(state: string): string {
    return this.legalRepresentationState.getStateColor(state?.toString());
  }

  public getStateText(state: string): string {
    return this.legalRepresentationState.getStateText(state?.toString());
  }

  public getIconEditar(isExpanded: boolean): string {
    if (isExpanded) {
      return 'icon-close';
    } else {
      if (this.estadoPendente) {
        return 'icon-more';
      } else {
        return 'icon-edit';
      }
    }
  }

  public isItemReady(el: models.BeneficiaryListVM): boolean{

    //Valida se onif é colectivo
    const nifColectivo = !this.nifValidationService.isPessoaSingularNif(el.NIF);

    if (nifColectivo) {
      let isItemReady = isNotNullOrUndefinedOrEmpty(el.beneficiaryName);
      isItemReady = isItemReady && isNotNullOrUndefinedOrEmpty(el.NIF);
      isItemReady = isItemReady && (isNotNullOrUndefinedOrEmpty(el.reimbursementFuneralBenefit) ||
        isNotNullOrUndefinedOrEmpty(el.funeralAllowanceBenefit) ||
        isNotNullOrUndefinedOrEmpty(el.survivalPensionBenefit));
      return isItemReady;
    } else {

      // Validar se item (beneficiario) tem os campos todos preenchidos
      let isItemReady = isNotNullOrUndefinedOrEmpty(el.beneficiaryName);

      isItemReady = isItemReady && isNotNullOrUndefinedOrEmpty(el.dateOfBirth);
      isItemReady = isItemReady && isNotNullOrUndefinedOrEmpty(el.hasNacPT);
        //isNotNullOrUndefinedOrEmpty(el.hasNIFPT) &&
      isItemReady = isItemReady && isNotNullOrUndefinedOrEmpty(el.NIF);
      //isItemReady = isItemReady && (this.isFuneraryOrService?.toString() == 'true' ||
      //    (el.hasLegalRepresentation?.toString() == 'true' );
      isItemReady = isItemReady && isNotNullOrUndefinedOrEmpty(el.gender);
      isItemReady = isItemReady && isNotNullOrUndefinedOrEmpty(el.civilStateDeathDate);
        // TODO: VER quando tivermos representação legal // isNotNullOrUndefinedOrEmpty(el.representationType) &&
      isItemReady = isItemReady && isNotNullOrUndefinedOrEmpty(el.identificationDocumentType);
      isItemReady = isItemReady && isNotNullOrUndefinedOrEmpty(el.identificationNumberFirst);
        // isNotNullOrUndefinedOrEmpty(el.identificationNumberLast) &&
      isItemReady = isItemReady && (
        isNotNullOrUndefinedOrEmpty(el.reimbursementFuneralBenefit) ||
        isNotNullOrUndefinedOrEmpty(el.funeralAllowanceBenefit) ||
        isNotNullOrUndefinedOrEmpty(el.survivalPensionBenefit));
      return isItemReady;
    }
  }

  public expandNewItem(newItem: boolean) {
    this.isOnEdit.emit(true);
  }

  public isClosingAction() {
    this.isOnEdit.emit(false);
  }

  public onBeneficiaryChanged(newWorkAbroadList: models.BeneficiaryListVM[]) {
    this.model.beneficiaryList = newWorkAbroadList;
    this.expandedRowIndex = null;
    this.expandNewBeneficiary = false;
    this.listChanged.emit(this.model.beneficiaryList);
  }

  removeFromList(currentList: any[], tableItem: models.BeneficiaryListVM, event: MouseEvent) {
    const indexToRemove = currentList.findIndex(b => b.beneficiaryID == tableItem.beneficiaryID)
    if (this.expandedRowIndex == null || this.expandedRowIndex == indexToRemove) {
      confirmRemoveFromList(currentList, indexToRemove, this.modalService).subscribe(result => {
        if (result) {
          this.BeneficiaryHelperService.docFaturaOuReciboChange(true, tableItem);
          this.BeneficiaryHelperService.docCerNascimentoReqChange(true, tableItem);
          this.BeneficiaryHelperService.docAtestadoJuntaFreguesiaChange(true, tableItem);
          this.BeneficiaryHelperService.docDeclCompHonraChange(true, tableItem);
          
          this.BeneficiaryHelperService.docProvaEscolarChange(true, tableItem, this.deathDate);
          this.BeneficiaryHelperService.docComprovativoSSChange(true, tableItem);
          this.BeneficiaryHelperService.docSentencaChange(true, tableItem);
          this.BeneficiaryHelperService.docDeclaracaoIRSChange(true, tableItem);
          this.BeneficiaryHelperService.docDeclaracaoPensaoAlimentosChange(true, tableItem);
          this.BeneficiaryHelperService.docPrestacoesFamiliaresChange(true, tableItem);
          this.BeneficiaryHelperService.docPSIChange(true, tableItem);
          this.BeneficiaryHelperService.docCertidaoIsensaoIRSChange(true, tableItem);
          this.BeneficiaryHelperService.docComprovativoIBANChange(true, tableItem);

        }

      });
    }
    event.stopPropagation();
  }

  expandRow(i) {
    if (this.expandedRowIndex == i)
      this.expandedRowIndex = null;
    else if (this.expandedRowIndex == null)
      this.expandedRowIndex = i;
    this.expandNewItem(true);
  }



  public benefitLabelAppearingFunction(survivalPensionBenefit, reimbursementFuneralBenefit, funeralAllowanceBenefit): String {
    let benefits: String[] = []
    if (!isNullOrUndefined(survivalPensionBenefit) && survivalPensionBenefit) {
      benefits.push("Pensão de sobrevivência")
    }

    if (!isNullOrUndefined(reimbursementFuneralBenefit) && reimbursementFuneralBenefit) {
      benefits.push("Reembolso de despesas de funeral")
    }

    if (!isNullOrUndefined(funeralAllowanceBenefit) && funeralAllowanceBenefit) {
      benefits.push("Subsídio de morte")
    }

    if (isNullOrUndefined(survivalPensionBenefit) && isNullOrUndefined(reimbursementFuneralBenefit) && isNullOrUndefined(funeralAllowanceBenefit)) {
      return "Por definir"
    }

    return benefits.join(", ")
  }


  public legalRepresentationLabelAppearingFunction(legalRepresentation: String): String {
    if (legalRepresentation?.toString() == 'true') {
      return "Sim"
    } else if (legalRepresentation?.toString() == 'false') {
      return "Não"
    } else {
      return "Por definir"
    }
  }

  public legalRepresentationNameLabelAppearingFunction(legalRepresentation: String, legalRepresentationName: String): String {
    if (legalRepresentation?.toString() == 'true') {
      return legalRepresentationName
    } else {
      return "Não aplicável"
    }
  }

  public representationTypeLabelAppearingFunctionDeprecated(representationType): String {
    switch (representationType?.toString()) {
      case 'RLFMMI': {
        return "Representação legal de filhos menores ou maiores incapazes"
      }
      case 'RLAA': {
        return "Representação legal através de advogado"
      }
      case 'RLEP': {
        return "Representação legal entre partes"
      }
      case 'OUTR': {
        return "Outros"
      }
      default: {
        return "Por definir"
      }
    }
  }

  public hasIconRL(item: models.BeneficiaryListVM): boolean {
    let result: boolean = item.NIF != this.senderNIF;
    result = result;
    return result;
  }
}
